// create a container and set the full-size image as its background
function createOverlay(image) {
  if (!image.parentElement.querySelector('.image-magnify-full-size')) {
    const overlayImage = document.createElement('img');
    overlayImage.setAttribute('src', `${image.src}`);
    overlay = document.createElement('div');
    prepareOverlay(overlay, overlayImage);

    image.style.opacity = '50%';
    //toggleLoadingSpinner(image);

    overlayImage.onload = () => {
      //toggleLoadingSpinner(image);
      image.parentElement.insertBefore(overlay, image);
      image.style.opacity = '100%';
    };

    return overlay;
  } else {
    return image.parentElement.querySelector('.image-magnify-full-size');
  }
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'white';
  container.style.backgroundRepeat = 'no-repeat';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading-overlay__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `calc(${xPosition / (image.clientWidth / 100)}% - ${-64 + (xPosition / image.clientWidth) * 128}px)`;
  const yPercent = `calc(${yPosition / ((image.clientWidth * ratio) / 100)}% - ${
    -64 + (yPosition / (image.clientWidth * ratio)) * 128
  }px)`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  for (const arrow of Array.from(document.querySelectorAll('.pdp__main__slider .fpslide__arrow'))) {
    arrow.style.display = 'none';
  }
  overlay.onclick = () => {
    overlay.remove();
    for (const arrow of Array.from(document.querySelectorAll('.pdp__main__slider .fpslide__arrow'))) {
      arrow.style.display = '';
    }
  };
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => {
    overlay.remove();
    for (const arrow of Array.from(document.querySelectorAll('.pdp__main__slider .fpslide__arrow'))) {
      arrow.style.display = '';
    }
  };
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    if (window.innerWidth >= 1000) {
      image.onclick = (event) => {
        magnify(image, zoomRatio);
        moveWithHover(image, event, zoomRatio);
      };
    }
  });
}

enableZoomOnHover(2);
